export default __webpack_public_path__ + "static/media/page-not-found.c90f74e6.png";